


export default function Intro() {
  return (
    <>
    

      <div className="custom-intro" >
        {/* <div className="flex flex-col w-full mb-20"> */}
        <div className="intro-text">
          <p >
          
          I'm a passionate Web Developer with a knack for creating dynamic and responsive websites that deliver exceptional digital experiences.
           
          </p>
          <h2>My Skills</h2> <ul> <li><strong>Front-End Development</strong>: Expertise in HTML, CSS, JavaScript, and frameworks like React and Angular.</li> <li><strong>Back-End Development</strong>: Proficient in Node.js, Express, and databases such as MongoDB and MySQL.</li> <li><strong>Responsive Design</strong>: Focused on creating seamless experiences across all devices and screen sizes.</li> <li><strong>Version Control</strong>: Skilled in using Git and GitHub for collaborative and efficient code management.</li> </ul>
          <h2>My Journey</h2> <p> My journey into web development started in a place you might not expect – student affairs in higher education. While I found supporting students quite rewarding, I realized that my personal growth lied elsewhere and I found myself increasingly drawn to the world of technology specifically web development.

Determined to make a change, I began teaching myself the basics of HTML, CSS, and JavaScript. The more I learned, the more fascinated I became with the ability to create interactive and visually appealing websites from scratch. This newfound passion led me to enroll in an intensive coding bootcamp, where I immersed myself in front-end and back-end development.
Today, as a web developer, I bring a unique perspective to the table. My experience in student affairs has instilled in me a deep understanding of user needs and a commitment to creating accessible and intuitive digital experiences.  
 </p> 
          
          <h2>What I Offer</h2> <ul> <li><strong>Custom Web Solutions</strong>: Tailored websites that meet your unique needs and goals.</li> <li><strong>User-Centered Design</strong>: Websites designed with a focus on usability and user experience.</li> <li><strong>Continuous Improvement</strong>: Committed to staying up-to-date with industry trends and best practices.</li> </ul> <h2>Let’s Connect</h2> <p> I’m always excited to take on new challenges and collaborate with like-minded individuals. Feel free to explore my portfolio, check out my projects, and get in touch! </p>

        </div>
        </div>
    
    
    </>
  );
}


